import React from "react";
import { globalService as gs } from "../../../common/services";


const Lobby = ({
  username,
  handleUsernameChange,
  roomName,
  handleRoomNameChange,
  handleSubmit,
  connecting,
  item,
}) => {
  return (
    <form onSubmit={handleSubmit} className="mb-3">
      {/* <h2>Enter a room</h2>
      <div>
        <label htmlFor="name">Name:</label>
        <input
          type="text"
          id="field"
          value={username}
          onChange={handleUsernameChange}
          readOnly={connecting}
          required
        />
      </div>

      <div>
        <label htmlFor="room">Room name:</label>
        <input
          type="text"
          id="room"
          value={roomName}
          onChange={handleRoomNameChange}
          readOnly={connecting}
          required
        />
      </div> */}
      {/* <iframe src={gs.rootUrl} allow="geolocation; microphone; camera"></iframe> */}

      <button type="submit" className="btn btn-primary" disabled={connecting}>
        {connecting ? "Connecting" : "Join"}
      </button>
    </form>
  );
};

export default Lobby;
